import React from 'react';
import SequentialPackSystem from '../components/draft/SequentialPackSystem';

function DraftPage({ user, setPage, leagueId, leagueName }) {
    // Store teamId in localStorage when DraftPage loads
    React.useEffect(() => {
        if (user?.id) {
            localStorage.setItem('draftTeamId', user.id);
            console.log('DraftPage: Stored teamId in localStorage:', user.id);
        }
    }, [user]);

    return (
        <div className="draft-page" style={{
            minHeight: '100vh',
            backgroundImage: 'url(/art/stadium.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }}>
            <SequentialPackSystem
                user={user}
                teamId={user?.id}
                leagueId={leagueId}
                setPage={setPage}
            />
        </div>
    );
}

export default DraftPage;